<template>
  <div class="row justify-content-center refs-input-inner">
    <div v-for="(field, index) of fields" class="col-12 refs-input" :class="listClass(index)">
      <boolean-input v-if="field.type === 'boolean' || field.type === fieldTypes('BOOLEAN')"
                     :required="getRequired(field)"
                     :label="field.label"
                     :name="'custom-input-' + field.id"
                     :placeholder="field.placeholder"
                     :read-only="field.read_only"
                     :val="field.value || null"
                     @input="onInput(field.id, $event)"
      />
      <number-input v-else-if="field.type === 'number' || field.type === fieldTypes('NUMERIC')"
                    :required="getRequired(field)"
                    :label="field.label"
                    :name="'custom-input-' + field.id"
                    :min="field.min"
                    :max="field.max"
                    :placeholder="field.placeholder"
                    @input="onInput(field.id, $event)"
                    :value="field.value"
                    :type="field.range ? 'range' : 'number'"
                    :read-only="field.read_only"
      />
      <select-input v-else-if="(field.type === 'select' || field.type === fieldTypes('DROP_DOWN_MENU')) && field.options.length > 0"
                    :value="{ value: field.value, label: getSelectOptionLabel(field) }"
                    :required="getRequired(field)"
                    :label="field.label"
                    :name="'custom-input-' + field.id"
                    :options="field.options"
                    optionsLabel="label"
                    :searchable="true"
                    :placeholder="field.placeholder"
                    :read-only="field.read_only"
                    @input="onInput(field.id, $event)"
      />

      <text-input v-else-if="field.type === 'text' || field.type === fieldTypes('TEXT') || field.type === fieldTypes('EMAIL') || field.type === fieldTypes('PHONE')"
                  v-model="field.value"
                  :required="getRequired(field)"
                  :label="field.label"
                  :name="'custom-input-' + field.id"
                  :placeholder="field.placeholder"
                  :read-only="field.read_only"
                  :max-length="maxLength"
                  :type="getTextInputType(field.type)"
                  @input="onInput(field.id, $event)"
      />

      <p v-else-if="field.type === 'paragraph' || field.type === fieldTypes('PARAGRAPH')">
        {{ field.label }}
      </p>

      <text-input v-else
                  v-model="field.value"
                  :required="getRequired(field)"
                  :label="field.label"
                  :name="'custom-input-' + field.id"
                  :placeholder="field.placeholder"
                  :read-only="field.read_only"
                  @input="onInput(field.id, $event)"
      />
      <hr class="separate" v-if="isFormation && index === isFirst">
    </div>
  </div>
</template>

<script>
import booleanInput from '@/components/frontoffice/form/customInput/boolean'
import numberInput from '@/components/frontoffice/form/customInput/number'
import selectInput from '@/components/frontoffice/form/customInput/select'
import textInput from '@/components/frontoffice/form/customInput/text'
import { fieldTypes } from '@/utils/fieldTypeCodes'
import fields from '../../../../conf/fields'

export default {
  data () {
    return {
      isFormation: this.$store.getters['research/context'] === 'formation',
      isFirst: 0
    }
  },
  components: {
    booleanInput,
    numberInput,
    selectInput,
    textInput
  },
  props: {
    fields: {
      type: Array,
      required: true
    },
    noRequiredField: {
      type: Boolean,
      default: false
    },
    verticalClass: {
      type: Boolean,
      default: false
    },
    maxLength: {
      type: Number,
      default: 999
    }
  },

  methods: {

    listClass (index) {
      if (this.verticalClass) return ''

      let ret = 'col-md-6'

      if (this.isFormation) {
        if (index === this.isFirst) {
          return this.fields.length > 2 ? 'col-md-12' + ' col-lg-6' : ret
        }
        return this.fields.length > 2 ? ret + ' col-lg-12' : ret
      }
      return this.fields.length > 2 ? ret + ' col-lg-4' : ret
    },

    onInput (inputId, newVal) {
      this.$emit('input', {
        id: inputId,
        value: newVal
      })
    },

    getSelectOptionLabel (field) {
      let value = field.value
      if (field.value) {
        return field.options.find(function (option) {
          return option.value === value
        }).label
      }
    },

    getRequired (field) {
      return this.noRequiredField ? false : field.required || false
    },

    fieldTypes (type) {
      return fieldTypes[type] || null
    },

    getTextInputType (type) {
      switch (type) {
        case this.fieldTypes('EMAIL'):
          return 'email'
        case this.fieldTypes('PHONE'):
          return 'tel'
        default:
          return 'text'
      }
    }
  }
}
</script>
<style scoped>
.admin form .custom-input:not(.dates){
  border-bottom: none;
  margin-right: 1rem;
}

.admin form .custom-input {
  border-bottom: none;
  margin-top: 0;
  height: 90px;
}

.admin form .refs-input{
  padding-left: 0;
  padding-right: 0;
}

.admin .input-inner{
  border-bottom: none;
}
</style>
